/**
 * Product image gallery carousel powered by Glide.
 *
 * Large screens show two images with a peek of the next slide; below the large breakpoint
 * (990px) it falls back to a single image per view. Glide handles slide movement and wires up
 * the prev/next arrows and bullet navigation, so no bespoke scroll logic is needed here.
 *
 * Keep perView, gap, and peek in sync with the pre-mount layout in product-image-gallery.css.
 */
class ProductImageGallery extends HTMLElement {
  connectedCallback() {
    this.setup();
  }

  setup() {
    const slidesCount = Number.parseInt(this.dataset.slidesCount, 10);

    if (!Number.isFinite(slidesCount) || slidesCount <= 1) {
      return;
    }

    const setupId = (this._setupId = (this._setupId || 0) + 1);

    import('@glidejs/glide')
      .then(module => {
        if (setupId !== this._setupId || !this.isConnected) {
          return;
        }

        const Glide = module.default;

        this.carousel = new Glide(this, {
          type: 'carousel',
          startAt: 0,
          perView: 2,
          gap: 16,
          peek: { before: 0, after: 120 },
          breakpoints: {
            989: {
              perView: 1,
              peek: 0
            }
          }
        });

        this.carousel.mount();
      })
      .catch(() => {
        // Ignore import failures; gallery remains static when Glide cannot load.
      });
  }

  disconnectedCallback() {
    this._setupId = (this._setupId || 0) + 1;
    this.carousel?.destroy();
    this.carousel = undefined;
  }
}

customElements.get('product-image-gallery') ||
  customElements.define('product-image-gallery', ProductImageGallery);

export default ProductImageGallery;
